package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.components.closing_reports_content.component

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.SalesGroupTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model.SalesGroup
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun ClosingReportsSalesGroup(
    data: List<SalesGroup>?,
    windowSizeMode: WindowSizeModeEnum,
) {
    MediumContentTitle(
        title = Strings.current().salesGroups,
        marginBottom = Dimen.normalPadding,
    )

    val totalItems = data?.size ?: 0
    val totalAmount = data?.sumOf { it.amount ?: 0.0 }
    val totalDiscount = data?.sumOf { it.discount ?: 0.0 }
    val totalReduction = data?.sumOf { it.reduction ?: 0.0 }
    val totalFreeVat = data?.sumOf { it.mWStFree ?: 0.0 }
    val totalNormalVat = data?.sumOf { it.mWStNormal ?: 0.0 }
    val totalReducedVat = data?.sumOf { it.mWStReduced ?: 0.0 }
    val totalSpecialVat = data?.sumOf { it.mWStSpecial ?: 0.0 }
    val totalSalesVolume = data?.sumOf { it.total ?: 0.0 }

    val tableData = data?.map { salesGroup ->
        mapOf(
            "id" to salesGroup.id,
            SalesGroupTableHeadersEnum.SALES_GROUP.key to (salesGroup.salesGroup?.name ?: ""),
            SalesGroupTableHeadersEnum.NUMBER.key to (salesGroup.amount?.toString() ?: ""),
            SalesGroupTableHeadersEnum.DISCOUNT.key to formatToTwoDecimals(salesGroup.discount),
            SalesGroupTableHeadersEnum.REDUCTION.key to formatToTwoDecimals(salesGroup.reduction),
            SalesGroupTableHeadersEnum.FREE_VAT.key to formatToTwoDecimals(salesGroup.mWStFree),
            SalesGroupTableHeadersEnum.NORMAL_VAT.key to formatToTwoDecimals(salesGroup.mWStNormal),
            SalesGroupTableHeadersEnum.REDUCED_VAT.key to formatToTwoDecimals(salesGroup.mWStReduced),
            SalesGroupTableHeadersEnum.SPECIAL_VAT.key to formatToTwoDecimals(salesGroup.mWStSpecial),
            SalesGroupTableHeadersEnum.SALES_VOLUME.key to formatToTwoDecimals(salesGroup.total)
        )
    }

    // Create table columns
    val columns = SalesGroupTableHeadersEnum.entries.map { column ->
        TableColumn(
            header = column.title,
            key = column.key,
            isNumeric = column.isNumberic,
        )
    }

    // Create footer data
    val footerData = mapOf(
        SalesGroupTableHeadersEnum.SALES_GROUP.key to "${Strings.current().items} : $totalItems",
        SalesGroupTableHeadersEnum.NUMBER.key to formatToTwoDecimals(totalAmount),
        SalesGroupTableHeadersEnum.DISCOUNT.key to formatToTwoDecimals(totalDiscount),
        SalesGroupTableHeadersEnum.REDUCTION.key to formatToTwoDecimals(totalReduction),
        SalesGroupTableHeadersEnum.FREE_VAT.key to formatToTwoDecimals(totalFreeVat),
        SalesGroupTableHeadersEnum.NORMAL_VAT.key to formatToTwoDecimals(totalNormalVat),
        SalesGroupTableHeadersEnum.REDUCED_VAT.key to formatToTwoDecimals(totalReducedVat),
        SalesGroupTableHeadersEnum.SPECIAL_VAT.key to formatToTwoDecimals(totalSpecialVat),
        SalesGroupTableHeadersEnum.SALES_VOLUME.key to formatToTwoDecimals(totalSalesVolume)
    )

    CustomTable(
        columns = columns,
        data = tableData,
        height = Dimen.saleGroupTableHeight,
        footerType = FooterType.ALIGNED,
        footerData = footerData
    )
}